import ProjectHeroBandSite from "../../../components/ProjectHero/BandSite/ProjectHeroBandSite";
import ProjectDetailsBandSite from "../../../components/ProjectDetails/BandSite/ProjectDetailsBandSite";


function ProjectPageBandSite() {
    return (
        <>
            <ProjectHeroBandSite />
            <ProjectDetailsBandSite />
        </>
    )
}

export default ProjectPageBandSite;